import styles from "./index.module.scss";

const RulesPage = () => {
  return (
    <div className={styles.rulesPage}>
      <h1 className={styles.title}>道路救援服务细则</h1>
      <div>1. 前提条件</div>
      <div className={styles.info}>
        本道路救援服务实施细则第 2
        条所述之道路救援服务应仅由《小鹏汽车服务权益告知书》中提及的"您"的小鹏汽车享有。在本道路救援服务实施细则中，“您"将被称为”小鹏车主"。
      </div>
      <div>2. 服务范围</div>
      <div className={styles.info}>
        汽车发生
        故障*①而无法行驶时，小鹏公司将在小鹏汽车整车质保期内，根据本道路救援服务实施细则的条款与条件为小鹏汽车提供在中华人民共和国境内(不含香港特别行政区、澳门特别行政区及台湾地区道路救援服务("道路救援服务")。道路救援服务的具体服务方式详见本道路救援服务实施细则下文第
        3 条之规定。
      </div>
      <div>3. 服务方式</div>
      <div className={styles.info}>
        小鹏公司将根据小鹏汽车的实际故障情况，决定提供如下一种或数种道路救援服务:
      </div>
      <div className={styles.info}>
        (a)远程救援服务，即通过远程手段诊断，排除小鹏汽车的故障;
      </div>
      <div className={styles.info}>
        (b)现场诊断服务，即安排小鹏公司移动服务车及服务专员赶赴小鹏汽车故障现场进行诊断;
      </div>
      <div className={styles.info}>
        (c)拖车救援服务，即安排小鹏公司指定的道路救援服务商，将小鹏汽车拖送至小鹏城市服务中心、授权服务中心或小鹏超级充电站；
      </div>
      <div className={styles.info}>
        (d)困境救援服务，即安排小鹏公司指定的道路救援服务商通过其专业救援设备(如大型吊车等)将小鹏汽车牵引至可拖运状态并拖送至小鹏城市服务中心或授权服务中心或小鹏超级充电站。
      </div>
      <div className={styles.info}>
        (e)特殊路段救援服务，即由小鹏公司直接或协助车主联系当地交警或政府指定的拖车服务实体("第三方救援服务实体")，将小鹏汽车拖送至小鹏公司指定的地点，并后续由小鹏公司指定的道路救援服务商将小鹏汽车拖送至小鹏公司指定的小鹏城巿服务中心或授权服务中心或小鹏超级充电站。
      </div>
      <div>4. 服务费用</div>
      <div className={styles.info}>
        在小鹏车主及小鹏汽车符合本道路救援服务实施细则所规定的道路救援服务情形的情况下，小鹏公司将承担以下提供道路救援服务的费用:
      </div>
      <div className={styles.info}>
        (a)小鹏公司将承担在道路救援服务过程中小鹏公司自行产生的提供本道路救援服务实施细则第3条(a)(b)(c)所规定的远程救援服务、现场诊断服务、拖车救援服务的费用;
      </div>
      <div className={styles.info}>
        (b)当发生本道路救援服务实施细则第3(d)(e)条所规定的需要困境救援、特殊路段救援服务的情形时，此等费用应由小鹏车主或小鹏汽车驾驶人承担。
      </div>
      <div>5. 除外情形</div>
      <div className={styles.info}>
        尽管有本道路救援服务实施细则第2条的规定，敬请注意，小鹏公司不对以下所规定的情形提供道路救援服务:
      </div>
      <div className={styles.info}>
        (a)除法律法规另有规定外，如果存在下列情形之一并因此导致小鹏汽车产生故障而无法行驶的，小鹏公司不对该等情形下的小鹏汽车提供道路救援服务:
      </div>
      <div className={styles.info}>
        (i)小鹏汽车被用于特殊使用条件或使用目的，如出租或其他情况包括但不限于比赛竞技、表演娱乐、试验、军事行动、征用、运送易燃易爆物品等;
      </div>
      <div className={styles.info}>
        (ii)小鹏汽车的驾驶人存在酒驾、毒驾等违法行为或参与其他违法犯罪行为的。
      </div>
      <div className={styles.info}>
        (iii)因非产品质量或者意外事故导致无法行驶的情形，例如：交通事故、车胎扎钉、爆胎、电量耗尽等。*②
      </div>
      <div className={styles.info}>
        (b)对于任何由于不可抗力事件导致道路救援服务无法提供的，小鹏公司不应承担任何责任。不可抗力事件包括但不限于自然灾害、战争、暴乱、叛乱、政治示威、抢劫、罢工、停工、军事或反恐行动等。小鹏公司将在不可抗力事件消除后继续提供道路救援服务。
      </div>
      <div className={styles.info}>
        (c)法律法规、《小鹏汽车服务权益告知书》或本道路救援服务实施细则规定的小鹏公司不予提供道路救援服务的其他情形。
      </div>
      <div>6. 其他约定</div>
      <div className={styles.info}>
        本道路救援服务实施细则自小鹏汽车交付至小鹏车主后，立即生效。如本道路救援服务实施细则有任何未尽事宜，小鹏公司将参照《小鹏汽车用户手册》、《小鹏汽车保修保养手册》或法律法规之规定予以处理。如本道路救援服务实施细则有任何更新，应以小鹏公司不时更新并发布的最新版本为准。
      </div>
      <div className={styles.info}>
        *①故障：指因产品质量问题导致的车辆使用障碍。
      </div>
      <div className={styles.info}>
        *②2022年3月31日前签订《小鹏汽车购买协议》的首任车主不受5
        (a)(iii)条款限制。
      </div>
      <div className={styles.info}>
        *③2025年12月31日（含）前签订《小鹏汽车购买协议》的车主不受2条款的质保期限制，车辆使用寿命周期内均可享受无忧救援服务。
      </div>
    </div>
  );
};

export default RulesPage;
